var $ = window.jQuery

$(function () {
	var $body = $('body')

	$body.is('.page-template-aubuchon-difference') && teamPage()
	$body.is('.page-template-model-locations') && modelLocationsPage()

	function teamPage() {
		var $container
		var vimeoIframe

		$('#play_btn').on('click', function () {
			$container = $(this).closest('.faded-header')
			vimeoIframe = document.createElement('IFRAME')
			vimeoIframe.allowFullscreen = true
			vimeoIframe.className = 'lazyload'
			vimeoIframe.setAttribute(
				'data-src',
				'https://player.vimeo.com/video/377628112#t=2s?title=0&byline=0&portrait=0&autoplay=1'
			)
			$container[0].appendChild(vimeoIframe)
			$container
				.addClass('loading-background')
				.animate({ height: '55.8vw' }, 1100)
			$body.addClass('show-video')
		})

		$('#close_vid_btn').on('click', function () {
			var height = $container.height()
			$container.css('height', height)
			$body.removeClass('show-video')
			$container
				.removeClass('loading-background')
				.animate({ height: '30em' }, 750)
			setTimeout(function () {
				$container[0].removeChild(vimeoIframe)
			}, 500)
		})
	}

	function isIE(userAgent) {
		userAgent = userAgent || navigator.userAgent
		return (
			userAgent.indexOf('MSIE ') > -1 ||
			userAgent.indexOf('Trident/') > -1 ||
			userAgent.indexOf('Edge/') > -1
		)
	}

	function modelLocationsPage() {
		var markers = []
		var geocoder = new google.maps.Geocoder()
		var bounds = new google.maps.LatLngBounds()
		var infoWindow = new google.maps.InfoWindow()
		var map = new google.maps.Map(document.getElementById('map'), {
			scrollwheel: false,
			mapTypeControl: false,
			streetViewControl: false,
		})

		$('.locations > [data-address]').each(function (i, el) {
			var $el = $(el)
			var addr = $el.data('address')
			if (!addr) {
				return true
			}

			var marker
			var icon = {
				url: isIE()
					? 'https://i.imgur.com/kfgXty5.png'
					: 'data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2068.7%2098%22%20height%3D%2298%22%20width%3D%2268.7%22%3E%3Cpath%20fill%3D%22%23000%22%20stroke%3D%22%23dbae75%22%20stroke-width%3D%224%22%20d%3D%22M34.33%202A32.33%2032.33%200%200%200%202%2034.33c0%2029.83%2032.33%2060.81%2032.33%2060.81S66.66%2061%2066.66%2034.33A32.33%2032.33%200%200%200%2034.33%202z%22%2F%3E%3Cpath%20fill%3D%22%23dbae75%22%20d%3D%22M34.33%2045.85a13.4%2013.4%200%201%201%2013.4-13.4%2013.4%2013.4%200%200%201-13.4%2013.4z%22%2F%3E%3C%2Fsvg%3E',
				scaledSize: new google.maps.Size(32, 46),
			}

			var openInfoWindow = function () {
				resetMarkers()
				infoWindow.close()

				var ico = $.extend({}, icon)
				infoWindow = new google.maps.InfoWindow({
					content: $el.find('h4').text(),
				})

				ico.scaledSize = new google.maps.Size(46, 66)
				marker.setZIndex(100)
				marker.setIcon(ico)

				map.panTo(marker.getPosition())
				$el.addClass('active').siblings().removeClass('active')
				infoWindow.open(map, marker)
			}

			geocoder.geocode({ address: addr }, function (res, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					marker = new google.maps.Marker({
						position: res[0].geometry.location,
						icon: icon,
						map: map,
					})

					markers.push(marker)
					bounds.extend(marker.position)
					map.fitBounds(bounds)
					map.setZoom(Math.min(map.getZoom(), 9))

					google.maps.event.addListener(marker, 'click', openInfoWindow)
					$el.on('click', openInfoWindow)
				}
			})

			function resetMarkers() {
				markers.forEach(function (mapMarker) {
					mapMarker.setZIndex(1)
					mapMarker.setIcon(icon)
				})
			}
		})
	}
})